package co.maytes.standupbot.dashboard.components.motion

import co.maytes.standupbot.dashboard.styles.Motion
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.classNames

fun Modifier.pressable(): Modifier = classNames(Motion.PRESSABLE_CLASS)
